// src/components/ExportButtons.js
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import config from '../config';

const ExportButtons = ({ analysis, accepted }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      // Get accepted suggestions as replacements array
      const replacements = analysis.suggestions
        .filter((_, idx) => accepted[idx])
        .map(suggestion => [suggestion.original, suggestion.suggestion]);

      // Send request to backend to generate DOCX with replacements
      const response = await fetch(`${config.API_HOST}/download-docx`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          original_file: analysis.original_file,
          replacements: replacements
        })
      });

      if (!response.ok) {
        throw response.error;
      }

      // Download the file
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'optimized_resume.docx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export document. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
      <Button
        variant="contained"
        onClick={handleExport}
        disabled={isExporting || !analysis.suggestions.some((_, idx) => accepted[idx])}
      >
        {isExporting ? 'Exporting...' : 'Export as DOCX'}
      </Button>
    </Box>
  );
};

export default ExportButtons;
